import React, { Component } from 'react';
import axios from 'axios';
import { translate } from 'react-i18next';
import Conecctions from './MyConecctions.js';
import MySolisitudes from './MySolisitudes.js';
import { Redirect } from 'react-router-dom';

let cancelToken;
let state;
let tokenSession;

class MyConecctionsContainer extends Component {

    getInitState = () => {
        return {
            mySolisitudes: [],
            conecctions: [],
            myConecctions: [],
            profile: [],
            errorr: "",
            errorQuery: "",
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        if (this.state.conecctions.length === 0) {
            this.reload();
        }
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }


    reload = () => {
        this.getProfile({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
        });

        this.getmySolisitudes({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
        });

        this.getListConnections({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
        });
    }

    getProfile = (params) => {
        this.props.post(
            "/getProfileUser",
            params,
            (response) => this.didGetProfile(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getListConnections = (params) => {
        this.props.post(
            "/getListConecctions",
            params,
            (response) => this.didgetListConnections(response),
            (error) => this.handleErrorConnectiosResponse(error),
            cancelToken
        );
    }



    getmySolisitudes = (params) => {
        this.props.post(
            "/Portal_getmySolisitudes",
            params,
            (response) => this.didGetSolisitudes(response),
            (error) => this.handleErrorConnectiosResponse(error),
            cancelToken
        );
    }

    getdelateConnections = (params) => {
        this.props.post(
            "/delateConnections",
            params,
            (response) => this.diddelateConnections(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getaceptConnections = (params) => {
        this.props.post(
            "/aceptConnections",
            params,
            (response) => this.didaceptConnections(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetSolisitudes = (response) => {
        this.setState({ mySolisitudes: response })
    }

    didgetListConnections = (response) => {
        this.setState({ conecctions: response })
    }

    diddelateConnections(response) {
        alert("Conexion eliminada");
        this.reload();
    }

    didaceptConnections(response) {
        alert("Conexion establecida");
        this.reload();
    }

    didGetProfile = (response) => {
        this.setState({ profile: response })
    }

    handleErrorResponse = (error) => {
        alert('A ocurrido un error: ', error);
    }

    handleErrorConnectiosResponse = (error) => {
        
    }

    handlegetdelateConnections = (userId) => {
        this.getdelateConnections({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            contact_id: userId
        });
    }

    handleacceptConnections = (userId) => {
        this.getaceptConnections({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            contact_id: userId
        });
    }

    renderMySolisitudes = () => {
        return (
            <MySolisitudes
                MySolisitudes={this.state.mySolisitudes}
                handleacceptConnections={this.handleacceptConnections}
                handlegetdelateConnections={this.handlegetdelateConnections} />
        )
    }

    renderMyListConnections = () => {
        return (
            <Conecctions
                MyConecctions={this.state.conecctions}
                handleacceptConnections={this.handleacceptConnections}
                handlegetdelateConnections={this.handlegetdelateConnections}
                user={this.state.profile} />
        )
    }

    render() {
        const solicitude = this.state.mySolisitudes
        const { t } = this.props;
        if (!this.props.user.memberId) {
            return <Redirect to="/" />;
        }
        return (
            <div className="content-conecctions">
                <div className="container-conecctions-title">
                    <h2 className="page-header">{t('dashboard.conecctions.heading')}</h2>
                </div>
                <div>
                    <div className="content-conecctions-content">
                        <div className="mySolisitudes">
                            {solicitude.length > 0 ? (
                                <div>
                                    <h2 className="page-header">{t('dashboard.conecctions.requests')}</h2>
                                    {this.renderMySolisitudes()}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="content-conecctions-content">
                        <div id="conecctions">
                            <h2 className="page-header">{t('dashboard.conecctions.myconnection')}</h2>
                            {this.renderMyListConnections()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
export default translate('common')(MyConecctionsContainer);


// WEBPACK FOOTER //
// ./src/dashboard/myConecctions/MyConecctionsContainer.js